<app-auth-layout
  variant="split"
  [headline]="asideKey + '.headline' | transloco"
  [tagline]="asideKey + '.tagline' | transloco"
>
  <div [style.display]="isDivCreate">
    <h2 class="auth-title">{{ 'user.confirmLoginMfa.header' | transloco }}</h2>
    <p class="auth-subtitle">{{ 'user.confirmLoginMfa.title' | transloco }} {{ 'user.confirmLoginMfa.title2' | transloco }}</p>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <span class="field-label" id="mfa-code-label">{{ 'user.confirmLoginMfa.codeLabel' | transloco }}</span>
      <p-inputOtp
        formControlName="code"
        [integerOnly]="true"
        [length]="6"
        [class.otp-invalid]="messagesCode.length"
        aria-labelledby="mfa-code-label"
      />
      <small class="field-error" role="alert" *ngFor="let message of messagesCode">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="7.5" x2="12" y2="13" />
          <circle cx="12" cy="16.5" r="0.6" />
        </svg>
        <span>{{ message.summary }}</span>
      </small>

      <div class="auth-actions">
        <button class="chamfer" type="submit" [disabled]="isLoadingBtn">
          <i *ngIf="isLoadingBtn" class="pi pi-spin pi-spinner"></i>
          {{ 'user.confirmLoginMfa.verify' | transloco }}
        </button>
        <button class="chamfer outline" type="button" (click)="redirect()">{{ 'user.confirmLoginMfa.btnBack' | transloco }}</button>
      </div>
    </form>

    <p class="resend">
      {{ 'user.confirmLoginMfa.resend' | transloco }}
      <button type="button" class="text-link" (click)="redirect()">{{ 'user.confirmLoginMfa.resend2' | transloco }}</button>
    </p>
  </div>

  <div [style.display]="isDivExpired">
    <div class="auth-status-tile is-alert" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <circle cx="11" cy="12" r="8.5" />
        <polyline points="11,7 11,12 14,14" />
        <line x1="20" y1="3.5" x2="20" y2="8" />
        <circle cx="20" cy="11" r="0.6" />
      </svg>
    </div>
    <h2 class="auth-title">{{ 'user.confirmLoginMfa.title4' | transloco }}</h2>
    <p class="auth-subtitle">{{ 'user.confirmLoginMfa.sessionEnded' | transloco }}</p>
    <div class="auth-actions">
      <button class="chamfer" type="button" id="expired" (click)="expired()">{{ 'user.confirmLoginMfa.loginAgain' | transloco }}</button>
      <button class="chamfer outline" type="button" (click)="redirect()">{{ 'user.confirmLoginMfa.btnBack' | transloco }}</button>
    </div>
  </div>
</app-auth-layout>

<p-toast key="mfalogin" />
